/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminBrigade
 */
export interface OutputAdminBrigade {
    /**
     * 
     * @type {number}
     * @memberof OutputAdminBrigade
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminBrigade
     */
    name: string;
}

/**
 * Check if a given object implements the OutputAdminBrigade interface.
 */
export function instanceOfOutputAdminBrigade(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputAdminBrigadeFromJSON(json: any): OutputAdminBrigade {
    return OutputAdminBrigadeFromJSONTyped(json, false);
}

export function OutputAdminBrigadeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminBrigade {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputAdminBrigadeToJSON(value?: OutputAdminBrigade | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

